import { format } from 'date-fns'
import { useTranslation } from 'i11n/client'
import { forwardRef } from 'react'
import { BsCalendarEvent } from 'react-icons/bs'
import { Popover, PopoverContent, PopoverTrigger } from 'ui/popover'
import { Calendar } from 'ui/calendar'
import { Button } from 'ui/button'
import { cn } from 'ui/utils'
import { inputVariants } from 'ui/input'

export const CalendarField = forwardRef<
  HTMLButtonElement,
  {
    value?: string
    onChange: (date: Date | undefined) => void
  } & React.HTMLProps<HTMLButtonElement>
>(({ className, value, onChange, ...props }, ref) => {
  const t = useTranslation()

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          ref={ref}
          variant='outline'
          className={cn(
            inputVariants({
              variant: 'outline',
            }),
            'w-full flex items-center justify-start font-normal',
            className,
          )}
          {...props}
        >
          <BsCalendarEvent className='mr-2' />
          {value
            ? format(new Date(value), 'LLL dd, y')
            : t('Selecciona una fecha')}
        </Button>
      </PopoverTrigger>
      <PopoverContent className='w-full'>
        <Calendar
          captionLayout='dropdown'
          numberOfMonths={1}
          mode='single'
          selected={value ? new Date(value) : undefined}
          onSelect={onChange}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  )
})
